
export default {
    data() {
        return {
            path_list: ['/register/', '/login/', '/forgotPass/', '/404/'], //显示白色底部的页面
        }
    },
    created() {},
    methods: {},
}
